import { all, call, select, spawn, take } from 'typed-redux-saga';

import broadcastViewerRootSaga from '../client/pages/broadcast-viewer/features/broadcast/sagas';
import { permissionsSaga } from '../client/pages/call/features/permissions';
import { shareConferenceLinkWatcher } from '../client/pages/call/features/share-link';
import { rootGoloomCall } from '../client/pages/call/sagas';
import { conferencesHistorySaga } from '../client/pages/conferences-history/sagas';
import createBroadcastSaga from '../client/pages/create-broadcast/features/start-broadcast/sagas';
import createCallSaga from '../client/pages/main/features/create-call/sagas';
import planCallSaga from '../client/pages/planning/features/plan-call/sagas';
import configSaga from '../client/shared/features/config/sagas';
import { selectIsMeetingRoomIntegration } from '../client/shared/features/config/selectors';
import { diagnosticsSaga } from '../client/shared/features/diagnostics/sagas';
import { rootDownloadRecordSaga } from '../client/shared/features/download-record';
import moderationSaga from '../client/shared/features/moderation/sagas';
import { confirmNotificationSaga } from '../client/shared/features/notifications/confirm-notification';
import { psNotificationsSaga } from '../client/shared/features/notifications/ps-notifications';
import {
    initConnectionMessageReceivedAction,
    initIframeCommunicationSaga,
} from '../client/shared/features/parent-frame-communicator';
import { permissionsExtendedSaga } from '../client/shared/features/permissions-extended';
import promozavrSaga from '../client/shared/features/promozavr/sagas';
import { setRoomAgentToken } from '../client/shared/features/room-agent/sagas';
import { settingsModalSaga } from '../client/shared/features/settings-modal/slice';
import settingsSaga from '../client/shared/features/settings/sagas';
import userSagas from '../client/shared/features/user/sagas';
import { createLogger } from '../client/shared/helpers/loggerFacade';
import { setTranslatorToken } from '../client/shared/helpers/transport/translator-token/sagas';

export const logger = createLogger('root-saga');

export function createRootSaga() {
    return function* rootSaga(): Generator {
        yield* call(setTranslatorToken);
        yield* call(setRoomAgentToken);

        // Инициализируем подписку на сообщения от iframe
        yield* call(initIframeCommunicationSaga);

        // rootGoloomCall до гейта: watchConference слушает joinConference сразу, токен ему на старте не нужен
        yield* spawn(rootGoloomCall);

        // Для meeting-room обязательно ждем initMessage с токеном
        if (yield* select(selectIsMeetingRoomIntegration)) {
            yield* take(initConnectionMessageReceivedAction);
        }

        yield all([
            spawn(userSagas),
            spawn(rootDownloadRecordSaga),
            spawn(createCallSaga),
            spawn(planCallSaga),
            spawn(createBroadcastSaga),
            spawn(settingsSaga),
            spawn(settingsModalSaga),
            spawn(permissionsExtendedSaga),
            spawn(configSaga),
            spawn(psNotificationsSaga),
            spawn(confirmNotificationSaga),
            spawn(moderationSaga),
            spawn(broadcastViewerRootSaga),
            spawn(shareConferenceLinkWatcher),
            spawn(permissionsSaga),
            spawn(diagnosticsSaga),
            spawn(conferencesHistorySaga),
            spawn(promozavrSaga),
        ]);
    };
}
